import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 10 18",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.852 0.767 C 0.634 0.813,0.423 0.977,0.332 1.173 C 0.232 1.387,0.230 1.598,0.326 1.820 C 0.370 1.920,0.547 2.100,3.907 5.463 L 7.441 9.000 3.907 12.537 C 0.547 15.900,0.370 16.080,0.326 16.180 C 0.195 16.482,0.251 16.804,0.474 17.026 C 0.700 17.252,1.030 17.307,1.330 17.167 C 1.436 17.118,1.625 16.932,5.278 13.278 C 8.932 9.625,9.118 9.436,9.167 9.330 C 9.268 9.112,9.271 8.903,9.174 8.680 C 9.130 8.580,8.942 8.388,5.310 4.753 C 3.210 2.652,1.459 0.910,1.418 0.883 C 1.262 0.779,1.026 0.730,0.852 0.767 ",
		stroke: "none",
		fillRule: "evenodd"
	})
});
export default SvgCaretRight;
